import React, { useState } from "react";

export default function HistorialVeterinario({
  historialVeterinario,
  entradasConRecordatorios,
  isVetAccess,
  onOpenVisitaModal,
  onVerDashboardTratamiento,
  onStartTratamiento
}) {
  const [historialSectionOpen, setHistorialSectionOpen] = useState(false);

  function tieneMedicamentosTratables(entry) {
    if (!entry?.medicamentos?.length) return false;
    return entry.medicamentos.some(m => m.frecuenciaHoras && m.duracionDias);
  }

  return (
    <div
      className="expediente-card"
      style={{
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        border: '1px solid #e5e7eb',
        overflow: 'hidden'
      }}
    >
      {/* Header del card - colapsable */}
      <div
        onClick={() => setHistorialSectionOpen(!historialSectionOpen)}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '14px 16px',
          cursor: 'pointer',
          userSelect: 'none'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={{ fontSize: '18px' }}>📋</span>
          <span style={{ fontWeight: '600', fontSize: '15px', color: '#1f2937' }}>
            Historial Veterinario
          </span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {Object.values(historialVeterinario).flat().length > 0 && (
            <span style={{
              backgroundColor: '#f3f4f6',
              color: '#6b7280',
              fontSize: '12px',
              padding: '4px 10px',
              borderRadius: '20px',
              fontWeight: '500'
            }}>
              {Object.values(historialVeterinario).flat().length} visitas
            </span>
          )}
          <i
            className={`bi bi-chevron-${historialSectionOpen ? 'down' : 'right'}`}
            style={{ fontSize: '14px', color: '#9ca3af' }}
          ></i>
        </div>
      </div>

      {/* Contenido colapsable de Historial */}
      {historialSectionOpen && (
      <div style={{ padding: '0 16px 16px 16px' }}>
      {Object.keys(historialVeterinario).length === 0 ? (
        <div
          className="text-center py-4"
          style={{ color: '#9ca3af', fontSize: '14px' }}
        >
          <i className="bi bi-inbox" style={{ fontSize: '32px', display: 'block', marginBottom: '8px' }}></i>
          No hay visitas registradas aun.
        </div>
      ) : (
        <div>
          {Object.entries(historialVeterinario).map(([tipo, entradasDelTipo]) => (
            <div key={tipo} style={{ marginBottom: '12px' }}>
              <div
                style={{
                  fontSize: '13px',
                  fontWeight: '500',
                  color: '#6b7280',
                  marginBottom: '8px'
                }}
              >
                {tipo} ({entradasDelTipo.length})
              </div>
              {entradasDelTipo
                .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
                .map((entry) => {
                  const tipoIconos = {
                    'consulta': { icon: '🩺', color: '#3b82f6' },
                    'vacunacion': { icon: '💉', color: '#10b981' },
                    'desparasitacion': { icon: '💊', color: '#8b5cf6' },
                    'emergencia': { icon: '🚨', color: '#ef4444' },
                    'cirugia': { icon: '🏥', color: '#f59e0b' },
                    'analisis': { icon: '🔬', color: '#06b6d4' },
                    'estetica': { icon: '✨', color: '#ec4899' },
                    'otro': { icon: '📋', color: '#6b7280' }
                  };

                  const servicios = entry.tipos || (entry.tipo ? [entry.tipo.toLowerCase().replace(/ /g, '_').replace('á', 'a').replace('ó', 'o')] : []);

                  const isAnulado = entry.anulado === true;
                  const isCertificado = entry.certificado === true;

                  return (
                    <div
                      key={entry.id}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '10px 12px',
                        marginBottom: '6px',
                        backgroundColor: isAnulado ? '#fef2f2' : '#f9fafb',
                        borderRadius: '8px',
                        opacity: isAnulado ? 0.7 : 1,
                        border: isAnulado ? '1px solid #fecaca' : isCertificado ? '1px solid #86efac' : 'none'
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px', flexWrap: 'wrap' }}>
                          <span style={{
                            fontSize: '13px',
                            fontWeight: '500',
                            color: isAnulado ? '#991b1b' : '#1f2937',
                            textDecoration: isAnulado ? 'line-through' : 'none'
                          }}>
                            {entry.fecha ? new Date(entry.fecha).toLocaleDateString('es-MX', {
                              day: 'numeric',
                              month: 'short',
                              year: 'numeric'
                            }) : 'Sin fecha'}
                          </span>
                          {isAnulado && (
                            <span style={{ backgroundColor: '#fecaca', color: '#991b1b', fontSize: '9px', padding: '1px 5px', borderRadius: '4px', fontWeight: '500' }}>
                              ⚠️ Anulado
                            </span>
                          )}
                          {isCertificado && !isAnulado && (
                            <span style={{ backgroundColor: '#dcfce7', color: '#166534', fontSize: '9px', padding: '1px 5px', borderRadius: '4px', fontWeight: '500' }}>
                              ✓ Certificado
                            </span>
                          )}
                          {entry.tipoAutor === 'veterinario' && !isAnulado && (
                            <span style={{ backgroundColor: '#e0e7ff', color: '#3730a3', fontSize: '9px', padding: '1px 5px', borderRadius: '4px' }}>
                              🩺 Vet
                            </span>
                          )}
                          {servicios.length > 1 && !isAnulado ? (
                            servicios.slice(0, 3).map((servicio, idx) => {
                              const info = tipoIconos[servicio] || tipoIconos['otro'];
                              return (
                                <span key={idx} style={{ fontSize: '11px' }} title={servicio}>
                                  {info.icon}
                                </span>
                              );
                            })
                          ) : null}
                          {servicios.length > 3 && !isAnulado && (
                            <span style={{ fontSize: '10px', color: '#6b7280' }}>+{servicios.length - 3}</span>
                          )}
                          {entry.creadoConIA && !isAnulado && (
                            <span style={{ backgroundColor: '#7c3aed', color: '#fff', fontSize: '9px', padding: '1px 5px', borderRadius: '8px' }}>
                              IA
                            </span>
                          )}
                          {(entry.recetaUrl || entry.recetaPath) && !isAnulado && (
                            <span style={{ backgroundColor: '#dcfce7', color: '#166534', fontSize: '9px', padding: '1px 5px', borderRadius: '4px' }}>
                              📄
                            </span>
                          )}
                          {!isAnulado && entradasConRecordatorios[entry.id] && (
                            <span style={{ backgroundColor: '#fef3c7', color: '#92400e', fontSize: '9px', padding: '1px 5px', borderRadius: '4px', fontWeight: '500' }}>
                              💊 Tratamiento
                            </span>
                          )}
                        </div>
                        <div style={{
                          fontSize: '12px',
                          color: isAnulado ? '#991b1b' : '#6b7280',
                          textDecoration: isAnulado ? 'line-through' : 'none'
                        }}>
                          {isAnulado && entry.razonAnulacion
                            ? `Anulado: ${entry.razonAnulacion}`
                            : (entry.resumen || entry.notas?.substring(0, 60) || 'Sin observaciones')
                          }
                          {!isAnulado && entry.notas?.length > 60 && '...'}
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: '6px', alignItems: 'center', flexShrink: 0 }}>
                        {!isAnulado && !isVetAccess && tieneMedicamentosTratables(entry) && (
                          entradasConRecordatorios[entry.id] ? (
                            <button
                              className="btn btn-sm"
                              onClick={(e) => {
                                e.stopPropagation();
                                onVerDashboardTratamiento(entradasConRecordatorios[entry.id].tratamientoId);
                              }}
                              style={{
                                fontSize: '11px',
                                padding: '4px 8px',
                                backgroundColor: '#fef3c7',
                                color: '#92400e',
                                border: '1px solid #fcd34d',
                                borderRadius: '6px',
                                whiteSpace: 'nowrap'
                              }}
                              title={`Día ${entradasConRecordatorios[entry.id].diaActual}/${entradasConRecordatorios[entry.id].diasTotales}`}
                            >
                              💊 Día {entradasConRecordatorios[entry.id].diaActual}/{entradasConRecordatorios[entry.id].diasTotales}
                            </button>
                          ) : (
                            <button
                              className="btn btn-sm"
                              onClick={(e) => {
                                e.stopPropagation();
                                onStartTratamiento(entry);
                              }}
                              style={{
                                fontSize: '11px',
                                padding: '4px 8px',
                                backgroundColor: '#eff6ff',
                                color: '#1d4ed8',
                                border: '1px solid #bfdbfe',
                                borderRadius: '6px',
                                whiteSpace: 'nowrap'
                              }}
                              title="Crear plan de tratamiento con recordatorios"
                            >
                              🔔 Tratamiento
                            </button>
                          )
                        )}
                        <button
                          className="btn btn-sm"
                          onClick={() => onOpenVisitaModal(entry.id)}
                          style={{
                            fontSize: '12px',
                            padding: '6px 12px',
                            backgroundColor: '#fff',
                            color: '#374151',
                            border: '1px solid #e5e7eb',
                            borderRadius: '6px',
                            whiteSpace: 'nowrap'
                          }}
                        >
                          Ver
                        </button>
                      </div>
                    </div>
                  );
                })}
            </div>
          ))}
        </div>
      )}
      </div>
      )}
    </div>
  );
}
